import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { DashboardFacade } from 'src/app/modules/core/store/dashboard/dashboard.facade';
import { IWidgetConfiguration } from 'src/app/modules/widget/interfaces/widget';
import { DashboardService } from './dashboard.service';
import { catchError } from 'rxjs/operators';
import { UrlBuilderService } from 'projects/communication/src/app/services';

@Injectable({
  providedIn: 'root',
})
export class WrapperHeadedButtonsService {
  public viewWidgetCollection: IWidgetConfiguration[];
  public hasViewChange: boolean;
  public hasShowTable: boolean;
  public hasViewTable: boolean;
  public tableView$ = new Subject<boolean>();

  constructor(
    private http: HttpClient,
    private dashboardService: DashboardService,
    public dashboadFacade: DashboardFacade,
    private urlBuilder: UrlBuilderService,
  ) {
    this.viewWidgetCollection = [];
  }

  public changeView(component: any): void {
    this.hasViewChange = !this.hasViewChange;
    this.dashboadFacade.getIsChangeView(this.hasViewChange);
  }

  public showTable(): void {
    this.hasViewTable = !this.hasViewTable;
    this.tableView$.next(this.hasViewTable);
  }

  /**
   * get data excel report for widgets
   */
  public GetWidgetExcel(params: any, widgetPath: string): Observable<any> {
    // Pendiente el endpoint del dsh
    const url = `${this.urlBuilder.apiUrl}/${widgetPath}`;
    return this.http.request('GET', url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * Widget setter
   *
   * @param components
   */
  public setWidgetConfiguration(components: IWidgetConfiguration[]): void {
    for (const component of components) {
      component.componentData.componentId = component.rawComponent.componentId;
    }

    this.viewWidgetCollection = components.sort((a, b) => a.order - b.order);
  }

  public obsTableView(): Observable<boolean> {
    return this.tableView$.asObservable();
  }
}
